import { render } from "./ChooseFromLocation.vue?vue&type=template&id=3231626a"
import script from "./ChooseFromLocation.vue?vue&type=script&lang=js"
export * from "./ChooseFromLocation.vue?vue&type=script&lang=js"
script.render = render

export default script